import React, { Component } from 'react';
import PropTypes from 'prop-types';

class MicIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };
    this.MouseOver = this.MouseOver.bind(this);
    this.MouseOut = this.MouseOut.bind(this);
  }
  MouseOver() {
    this.setState({ hover: true });
  }
  MouseOut() {
    this.setState({ hover: false });
  }

  render() {
    const { item, containerClass, imageClass, textClass } = this.props;
    const { hover } = this.state;
    if (!this.state) return null;
    return (
      <div
        className={containerClass}
        onMouseOver={this.MouseOver}
        onMouseOut={this.MouseOut}
        onFocus={() => {}}
        onBlur={() => {}}
      >
        <a href={item.article_url} className="section-link">
          <img
            src={hover ? item.sector_image_hover : item.sector_image}
            className={hover ? `${imageClass}-hover` : imageClass}
            alt={item.sector_name}
          />
          <span className={textClass} style={{ opacity: hover ? 1 : 0 }}>
            {item.sector_name}
          </span>
        </a>
      </div>
    );
  }
}

MicIcon.defaultProps = {
  item: {
    sector_name: '',
    sector_image: '',
    sector_image_hover: '',
    article_url: ''
  },
  containerClass: 'section-image-div',
  imageClass: 'section-image',
  textClass: 'section-text'
};

MicIcon.propTypes = {
  item: PropTypes.shape({
    sector_name: PropTypes.string,
    sector_image: PropTypes.string,
    sector_image_hover: PropTypes.string,
    article_url: PropTypes.string
  }),
  containerClass: PropTypes.string,
  imageClass: PropTypes.string,
  textClass: PropTypes.string
};

export default MicIcon;
